import Vue from 'vue';
import store from 'store';
import { i18n } from 'lib/i18n.js';
import inViewport from 'in-viewport';
import {
  listProductsEventData,
  trackEvent,
} from '../../assets/js/lib/tracking';
import { htmlDecode } from '../../assets/js/utils/general';

export default {
  components: {
    'bb-product-card': () => import('./bb-product-card.vue'),
  },
  i18n,
  props: [
    'name',
    'description',
    'products',
    'idx',
    'limit',
    'selectedItems',
    'bundle',
  ],
  data() {
    return {
      selectedNum: 0,
      stepProducts: [],
    };
  },
  mounted() {
    this.stepProducts = this.setStepProducts();

    setTimeout(() => {
      inViewport(this.$el, this.handleItemsTracking);
    }, 1000);
  },
  computed: {
    listId() {
      return `bundle-step-${this.idx + 1}`;
    },
    stepTitle() {
      return `${this.idx + 1}. ${this.name}`;
    },
    selectedStepProducts() {
      return this.selectedItems.filter((item) =>
        this.products.some((product) => product.id === item.id),
      );
    },
    selectedText() {
      return `${this.selectedStepProducts.length}/${this.limit} ${this.$t(
        'products.card.selected',
      )}`;
    },
    hasAvailableProducts() {
      if (this.limit > 1) {
        return this.selectedStepProducts.length < this.limit;
      }
      return true;
    },
  },
  methods: {
    async handleItemsTracking() {
      const { products } = await listProductsEventData(this.stepProducts, {
        origin: document.body.dataset.origin,
        originProduct: document.body.dataset.originProduct,
        isBundleBuilder: true,
        bundleName: htmlDecode(this.bundle.title),
        bundleId: String(this.bundle.id),
        listId: `bundle-step-${this.idx + 1}`,
        listName: this.name,
      });

      trackEvent({
        event: 'view_item_list',
        site_section: window.__GLOBAL__.siteSection,
        component_name: 'Bundle Builder Product Card',
        step_number: this.idx + 1,
        selection: this.limit,
        bundle_type: 'bundle builder',
        bundle_name: htmlDecode(this.bundle.title),
        bundle_id: String(this.bundle.id),
        ecommerce: {
          bundled: 'true',
          item_list_id: this.listId,
          item_list_name: this.name,
          items: products,
        },
      });
    },
    setStepProducts() {
      const filteredProducts = this.products.reduce((acc, product) => {
        let title = product.title.split(window.__GLOBAL__.productDelimiter)[0];
        const selectedShades = this.products
          .map((product) => {
            if (product.title.includes(title)) {
              return product.id;
            }
          })
          .filter((p) => p);

        const existingProduct = acc.find((item) => item.title.includes(title));
        if (!existingProduct) {
          acc.push({ ...product, selectedShades });
        }
        return acc;
      }, []);

      return filteredProducts.map((fProduct, index) => {
        return {
          ...fProduct,
          index,
          listId: this.listId,
          listName: this.name,
        };
      });
    },
  },
  template: `
    <div class="bb-step">
      <div class="container">
        <div class="bb-step__header">
          <h2 class="h2" v-text="stepTitle"></h2>
          <div class="p1 light uppercase" v-text="selectedText"></div>
        </div>
        <div class="p6 bb-step__description" v-text="description" v-if="description"></div>
        <div class="bb-step__products">
          <div
            v-if="stepProducts.length"
            v-for="(product, index) in stepProducts"
            is="bb-product-card"
            :product="product"
            :key="product.id"
            :selected-items="selectedItems"
            :limit="limit"
            :step-products="products"
            :has-available-products="hasAvailableProducts"
            :step="idx"
            :name="name"
            :parent-title="name"
            :cardIndex="index"
            :parent-id="bundle.id"
            v-cloak>
          </div>
        </div>
      </div>
    </div>
  `,
};
